import React from "react"
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view";
import FieldReaction from "../../reaction";
import Reactions from "../../../../../model2/reaction/reactions";
import ReactionsList from "../../../../../gd-components/reactions/reactions-list/reactions-list";

// const debug = "FieldReaction_FormElementView"
const debug = false

type State = {
    showPopover : boolean
}

/**
 * The form element of a reaction field. The value is a list of reactions, so it cannot go through
 * the FieldPopover form component the field otherwise inherits - that one renders the value as a
 * plain React child, which an array of reactions is not.
 *
 * Reactions already on the field are toggled by clicking them (ReactionView stops the click from
 * reaching us), clicking anywhere else opens the picker to add a new one.
 */
export default class FieldReaction_FormElementView extends React.Component<FieldFormElementViewProps,State> {

    state : State = {
        showPopover : false
    }

    get field():FieldReaction {
        return this.props.field as unknown as FieldReaction
    }

    get reactions():Reactions {
        return Reactions.initFromJson(this.props.field.getViewValue(this.props.model))
    }

    // FieldFormElementView has already applied the field access check for us
    get canEdit():boolean {
        return !this.props.disabled
    }

    get classes():string {

        // min-h rather than the h-36 the other form elements use - reaction pills wrap, so the
        // element has to grow with them instead of clipping the rows that no longer fit. That is
        // also why the size option is not applied: nothing below 36 can hold a 26px pill
        return Classes("ui5-field-form-editable dropdown-form min-h-36", this.props.className, {
            "show-popover"  : this.state.showPopover,
            "is-disabled"   : this.props.disabled
        })
    }

    // FieldReaction_Popover talks back to its parent through onValueChange() and hidePopover()
    onValueChange = (value:any) => {

        debug && console.log(debug, "onValueChange", value)

        this.props.onChange && this.props.onChange(value)
    }

    hidePopover = () => {
        if (this.state.showPopover) this.setState({showPopover: false})
    }

    // never a toggle - a click on the element while the picker is open reaches its onClickOutside
    // first, which closes it, and the guard here keeps this click from opening it straight back up
    showPopover = () => {
        if (!this.state.showPopover && this.canEdit) this.setState({showPopover: true})
    }

    onToggleReaction = (reactionType:number) => {

        if (!this.canEdit) return

        this.onValueChange(this.field.toggleValue(this.props.model, reactionType))
    }

    render() {

        const field         = this.field
        const reactions     = this.reactions

        debug && console.log(debug, "render() isEmpty=", reactions.isEmpty, this.state)

        return (
            <div className={this.classes} onClick={this.showPopover}>

                {reactions.isEmpty &&
                    <div className="ui5-txt-no-accent-default txt-truncate">
                        {this.props.field.placeholder}
                    </div>
                }

                {!reactions.isEmpty &&
                    <ReactionsList reactions       = {reactions}
                                   toggleReaction  = {this.onToggleReaction}
                                   disabled        = {!this.canEdit}/>
                }

                {this.state.showPopover &&
                    <field.components.PopoverMenu parent = {this}
                                                  field  = {this.props.field}
                                                  model  = {this.props.model}/>
                }
            </div>
        )
    }
}
